import Axios from 'axios-observable';
import { pickResponse } from '../utils';
import { Cognito } from './cognito.types';
import { TokenResponse } from './types';
import { map } from 'rxjs/operators';
import jwtDecode from 'jwt-decode';
import { windowObj } from '@lib/common';

const authHttp = Axios.create({
  baseURL: windowObj.RAZZLE_VTR_PINT_BACKEND,
});

/**
 * @deprecated
 */
export function refreshAccessToken(refreshToken: string) {
  return authHttp
    .post<TokenResponse>('/api/v1/auth/refreshToken', null, {
      headers: { Authorization: `Bearer ${refreshToken}` },
    })
    .pipe(pickResponse());
}

/**
 * @deprecated
 */
export function login(username: string, password: string) {
  return authHttp
    .post<TokenResponse>('/api/v1/auth/login', { username, password })
    .pipe(pickResponse());
}

export function loginCognito(username: string, password: string) {
  return authHttp.post<Cognito.Response>('/api/v1/auth/login', { username, password }).pipe(
    pickResponse(),
    map(x => {
      const authorititesFromIdToken = jwtDecode(x['id_token'])['custom:authorities'];
      const role_id = jwtDecode(x['id_token'])['custom:role_id'];
      if (typeof window !== 'undefined') {
        localStorage.setItem('role_id', role_id);
      }
      if (authorititesFromIdToken.split(',').includes('DELI')) return x;
      else
        throw {
          response: {
            data: {
              message:
                'Looks like you do not have permissions to use DELI. Please contact your administrator. ',
            },
          },
        };
    })
  );
}

export function refreshCognitoToken(refreshToken: string) {
  return authHttp
    .post<Cognito.Response>('/api/v1/auth/refreshToken', null, {
      headers: { 'X-vtr-auth-rt': refreshToken, 'X-vtr-auth-src': 'cognito' },
    })
    .pipe(pickResponse());
}
